import { endpoints } from '@/config';
import get from './get';
/**
 * @param {string} scope - expression
 */
export default async function getTelemetryState(accountId, { scope, deviceId, deviceIds, property, properties, pivotProperty, offset, range, } = {}) {
    const resource = '/state';
    const overrides = {
        method: 'GET',
        url: `${endpoints.telemetry}${resource}`,
    };
    return get(overrides, {
        accountId,
        scope,
        deviceId,
        deviceIds,
        property,
        properties,
        pivotProperty,
        offset,
        range,
    }, { resource });
}
